var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 156,
    viewBox: "0 0 155 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.7692,
    y: 36,
    width: 83.4615,
    height: 84,
    rx: 2,
    fill: "#EC9301"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.591 90.8808L62.5307 88.8068L63.6151 85.5322L57.9763 86.6237L65.567 74.1799L71.5311 73.1975C72.0733 72.0696 74.0686 68.8968 77.7122 65.2291C82.2666 60.6446 92.4597 55.6235 100.376 54.8594C99.6167 62.8277 94.6285 73.0884 90.0741 77.6729C86.4306 81.3406 83.2786 83.349 82.1581 83.8948L81.1822 89.8984L68.8201 97.5393L69.9045 91.8632L66.6514 92.9548L64.591 90.8808ZM79.3387 72.9792C78.5003 73.8232 78.5003 75.1916 79.3387 76.0356C80.1772 76.8796 81.5365 76.8796 82.375 76.0356C83.2134 75.1916 83.2134 73.8232 82.375 72.9792C81.5365 72.1352 80.1772 72.1352 79.3387 72.9792ZM84.7606 67.5214C83.9222 68.3654 83.9222 69.7338 84.7606 70.5778C85.5991 71.4218 86.9584 71.4218 87.7969 70.5778C88.6354 69.7338 88.6354 68.3654 87.7969 67.5214C86.9584 66.6774 85.5991 66.6774 84.7606 67.5214Z",
    fill: "#FCFCFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5063 101.032C54.9762 99.3224 56.6533 95.1599 59.6029 92.1909C60.9909 90.7937 62.5669 91.6815 63.1813 92.3C63.7958 92.9186 64.6777 94.505 63.2898 95.9022C60.3402 98.8712 56.2051 100.559 54.5063 101.032Z",
    fill: "#FCFCFC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.0847a9eead3b68bfe9a8234f239e7f5a.svg";
export { ForwardRef as ReactComponent };